(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){
    var kids=Array.prototype.slice.call(e.target.parentElement.querySelectorAll('.bb-rv'));
    var i=kids.indexOf(e.target);
    setTimeout(function(){e.target.classList.add('bb-in')},Math.max(0,i)*90);
    io.unobserve(e.target);
  }})},{threshold:.2});
  document.querySelectorAll('.bb-rv').forEach(function(el){io.observe(el)});

  var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){
    var el=e.target,target=el.getAttribute('data-count');
    if(!target){cio.unobserve(el);return}
    var p=target.split(':'),total=parseInt(p[0],10)*60+parseInt(p[1],10),t0=performance.now();
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=target;cio.unobserve(el);return}
    (function tick(t){var pr=Math.min(1,(t-t0)/900),v=Math.round(total*(.2+.8*pr));
      el.textContent=Math.floor(v/60)+':'+String(v%60).padStart(2,'0');
      pr<1?requestAnimationFrame(tick):el.textContent=target})(t0);
    cio.unobserve(el);
  }})},{threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el){cio.observe(el)});

  var h=document.querySelector('[data-bb-pm]');
  if(h&&h.getAttribute('data-bb-pm')&&new Date().getHours()>=16){h.src=h.getAttribute('data-bb-pm')}
})();